import { QueryConfig } from "store/utils/query-config";

export const screenRecordingsDefaultQueryConfig: QueryConfig = {
  query: {},
  options: {
    sortBy: ["createdAt"],
  },
};
